import clsx from "clsx"
export default function Chevron({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-5) lg:w-(--space-7) h-auto')} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.2471 5.61426L13.4951 5.86133L7.86133 11.4951L7.61426 11.2471L2.22852 5.86133L2.47656 5.61426L3.41895 4.67188L3.66602 4.42383L7.86133 8.61914L11.8096 4.67188L12.0566 4.42383L13.2471 5.61426Z" />
    </svg>
  )
}
